// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { invoiceDetailSchema } from '@/billing/api/types';
import { z } from 'zod';

const openInvoiceResponseSchema = z.object({
  data: invoiceDetailSchema,
  metadata: responseMetadataSchema,
});

export async function openInvoice(invoiceKey: string) {
  const url = `/v1/invoice/${invoiceKey}/open`;
  const response = await api.post(url);

  const result = await parseResponse(openInvoiceResponseSchema, response.data, {
    schemaName: 'OpenInvoice',
    endpoint: url,
  });
  return result.data;
}
